module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/2_f252e03ac3ad00a25980cbd65839d7d4.jpg";